
































































































































































































































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import {ChartCardDashboardWings, PieChart} from 'wings-ui-components';
import {Action, Getter} from "vuex-class";
import {DateTime} from 'luxon'
import {notifyError} from "@/utils/notify-helper";
import { transformTransport } from '@/utils/download-helper';

const DISTRIBUTION_CREATE_KEYS = ['sms', 'call', 'email', 'push', 'viber', 'whatsapp', 'custom', 'mail_notify'] as const;

@Component({components: { ChartCardDashboardWings, PieChart }})
export default class Dashboard extends Vue {
  @Getter("transports") transports: any;
  @Getter("allowedPages") allowedPages: string[] | undefined;

  @Action("getTransports") actionGetTransports: any;
  @Action("getTemplates") actionGetTemplates: any;
  @Action("getBlacklists") actionGetBlacklists: any;
  @Action("getAddressBooks") actionGetAddressBooks: any;
  @Action("getDistributions") actionGetDistributions: any;
  @Action("getStatisticGroup") actionGetStatisticGroup: any;

  private distributions: any =  {
    PAYMENT_WAITING: 0,
    IN_PROGRESS: 0,
    STOPPED: 0,
    ON_MODERATION: 0,
    FINISHED: 0,
  }
  private templates: any = {
    SMS: null, Call: null, Email: null, Push: null, Viber: null, WhatsApp: null, 'Telegram OTP': null, Custom: null, 'Mail Notify': null
  }
  private addressBooks: any = {
    count: 0,
    contacts: 0,
  }
  private blacklists: any = {
    count: 0,
    contacts: 0,
  }
  private stats: any = {
    SMS: null, Call: null, Email: null, Push: null, Viber: null, WhatsApp: null, 'Telegram OTP': null, Custom: null, 'Mail Notify': null
  }
  private chartData: any[] = []

  private todayDate = DateTime.local().toISODate()
  private yesterdayDate = DateTime.local().plus({day: -1}).toISODate()

  private transportColors: any = {
    SMS: '#d92626', Call: '#32c5e9', Email: '#fc9f7f', Push: '#fddb5c', Viber: '#e7bcf3', WhatsApp: '#9fe6b8', 'Telegram OTP': '#54a0ff', Custom: '#228B22', 'Mail Notify': '#37a2da'
  }

  getTransportName(transport: string | { name?: string }): string {
    return typeof transport === 'string' ? transport : (transport?.name ?? '');
  }

  get allowedPagesList(): string[] {
    return Array.isArray(this.allowedPages) ? this.allowedPages : [];
  }

  get showDistributionsWidget(): boolean {
    const p = this.allowedPagesList;
    if (p.includes('menu.item.distr.status')) return true;
    return DISTRIBUTION_CREATE_KEYS.some(key => p.includes(`menu.item.distr.create.${key}`));
  }

  get showTemplatesWidget(): boolean {
    const p = this.allowedPagesList;
    return DISTRIBUTION_CREATE_KEYS.some(key => p.includes(`menu.item.templates.${key}`));
  }

  get showAddressBooksWidget(): boolean {
    return this.allowedPagesList.includes('menu.item.contacts.address.book');
  }

  get showBlacklistsWidget(): boolean {
    return this.allowedPagesList.includes('menu.item.contacts.black.lists');
  }

  hasTemplatesPage(transportName: string): boolean {
    return this.allowedPagesList.includes(`menu.item.templates.${transformTransport(transportName)}`);
  }

  canShowTransportStats(transportName: string): boolean {
    const key = transformTransport(transportName);
    const p = this.allowedPagesList;
    return p.includes(`menu.item.distr.create.${key}`) || p.includes(`menu.item.statistics.group.${key}`);
  }

  async created() {
    try {
      await this.actionGetTransports();
      const tasks: Promise<void>[] = [];
      if (this.showDistributionsWidget) tasks.push(this.getDistributions());
      if (this.showTemplatesWidget) tasks.push(this.getTemplates());
      if (this.showAddressBooksWidget) tasks.push(this.getAddressBooks());
      if (this.showBlacklistsWidget) tasks.push(this.getBlacklists());
      tasks.push(this.getStatistics());
      await Promise.all(tasks);
    } catch(error) {
      notifyError(error);
    }
  }

  async getDistributions() {
    const res = await this.actionGetDistributions({page_size: 1000000000});
    res.data.forEach((item:any) => {
      if (item.status in this.distributions) {
        this.distributions[item.status]++;
      }
    })
  }

  async getTemplates() {
    const transportNames = (this.transports || [])
      .map((t: string | { name?: string }) => this.getTransportName(t))
      .map((n: string) => (n && String(n).trim()) || '')
      .filter(Boolean)
      .filter((transportName: string) => this.hasTemplatesPage(transportName));
    await Promise.all(transportNames.map(async (transportName: string) => {
      if (!transportName) return;
      try {
        const templates = await this.actionGetTemplates({ transport: transportName });
        this.templates[transportName] = Array.isArray(templates) ? templates.length : 0;
      } catch {
        this.templates[transportName] = 0;
      }
    }));
  }

  async getAddressBooks() {
    const res = await this.actionGetAddressBooks();
    this.addressBooks.count = res.data.length
    this.addressBooks.contacts = res.data.reduce((accumulator:number, currentValue:any) => accumulator + currentValue.contacts, 0)
  }

  async getBlacklists() {
    const res = await this.actionGetBlacklists();
    this.blacklists.count = res.data.length
    this.blacklists.contacts = res.data.reduce((accumulator:number, currentValue:any) => accumulator + currentValue.contacts, 0)
  }

  async getStatistics() {
    const isoOpts = { includeOffset: false, suppressMilliseconds: true };
    const dateFrom = DateTime.local().startOf('month').toISO(isoOpts);
    const dateTo = DateTime.local().endOf('month').toISO(isoOpts);
    if (!dateFrom || !dateTo) return;
    const filter = {
      message_direction: 'mt',
      group_by: 'day',
      date_from: dateFrom,
      date_to: dateTo,
    };
    const transportNames = (this.transports || [])
      .map((t: string | { name?: string }) => this.getTransportName(t))
      .map((n: string) => (n && String(n).trim()) || '')
      .filter(Boolean)
      .filter((transportName: string) => this.canShowTransportStats(transportName));
    await Promise.all(transportNames.map(async (transportName: string) => {
      if (!transportName) return;
      try {
        const res = await this.actionGetStatisticGroup({ transport: transportName, filter });
        const data = this.getTransportStat(transportName, res.data);
        this.stats[transportName] = data;
        if (data?.month?.count) {
          this.chartData.push({
            name: transportName,
            value: data.month.count,
            itemStyle: { color: this.transportColors[transportName] },
          });
        }
      } catch {
        // skip failed transport
      }
    }));
  }

  getTransportStat(transport:string, data: any) {
    let month: any
    let today: any
    let yesterday: any

    today = yesterday = month = {count: 0, price: 0, duration: '00:00:00'}

    if (!data.messages) return null

    const todayItem = data?.messages?.find((item: any)=> item.date === this.todayDate)
    if (todayItem) today = {
      count: todayItem.total,
      price: Number(todayItem.partner_price)
    }

    const yesterdayItem = data?.messages?.find((item: any)=> item.date === this.yesterdayDate)
    if (yesterdayItem) yesterday = {
      count: yesterdayItem.total,
      price: Number(yesterdayItem.partner_price)
    }

    month = {
      count: data?.messages_summary?.total,
      price: data?.messages_summary?.partner_price
    }

    if (transport == 'Call') {
      if (todayItem) today.duration = todayItem.duration
      if (yesterdayItem) yesterday.duration = yesterdayItem.duration
      month.duration = data.messages_summary?.duration
    }

    return {transport, today, yesterday, month}
  }
}
